const formUnsubscribe = document.querySelector('.form-unsubscribe');

if (formUnsubscribe != null) {
	formUnsubscribe.onsubmit = (e) => {
		// e.preventDefault();

		if (window.confirm("You sure want to unsubscribe?")) {
			/*const data = new FormData(formUnsubscribe);
			const token = formUnsubscribe.querySelector('input[name="_token"]').value;
			const method = formUnsubscribe.getAttribute('method');
			const url = formUnsubscribe.getAttribute('action');

			const xhr = new XMLHttpRequest;
			xhr.open(method, url);
			xhr.send(data);
			xhr.onload = (e) => {
				if (xhr.status != 200) {
					console.log(`Error ${xhr.status}: ${xh.statusText}`)
				} else {
					console.log(xhr.response);
				}
			}*/

			formUnsubscribe.submit();
		}
	}
}
